export class ConditionProgramLoanTypeApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getConditionProgramLoanType() {
    return this.#http.get('/conditionProgramLoanType');
  }
}
